// Staff Portal — demo sandbox configuration.
//
// public/index.html assigns window.__app_id before this bundle loads, so every
// Firestore path in App.js already resolves into this visitor's own tree. These
// constants just give the demo-only code the same values by name.

export const SESSION_ID = window.__demo_session_id || "unknown";

// This visitor's private namespace: artifacts/{DEMO_NS}/…
export const DEMO_NS =
  typeof window.__app_id !== "undefined" ? window.__app_id : "demo-unknown";

// The pristine, admin-written namespace every session is cloned from.
export const SEED_NS = window.__demo_seed_ns || "demo-seed";

// The sample employee a visitor is signed in as. Must exist in the seed's
// allowedAccess/ids list and have a matching profile document.
export const DEMO_LOGIN_ID = "10001";

// Marks the visitor's namespace as fully cloned. Written last, so an interrupted
// clone is retried on the next visit rather than leaving a half-empty portal.
export const SEED_MARKER_DOC = "demoSeed";

// Top-level collections under artifacts/{ns}/public/data/.
// Anything seeded in scripts/demoSeedData.js but missing from this list is
// simply never copied into the visitor's namespace, and the module that reads
// it renders empty with no error anywhere.
export const SEED_COLLECTIONS = [
  "adminActivityLogs",
  "adminRoles",
  "allowedAccess",
  "allowedAccessBackups",
  "anniversarySmsLog",
  "appMeta",
  "birthdaySmsLog",
  "companyInfo",
  "contactRequests",
  "conversations",
  "dailyReports",
  "eventPhotoAlbums",
  "eventPhotos",
  "events",
  "eventVideos",
  "learningVideos",
  "loginPopups",
  "news",
  "pendingProfiles",
  "pushNotificationHistory",
  // Not seeded — written at runtime by licenseService.js. Listed so the pruner
  // reaps it with the rest of the sandbox; cloning it is a harmless no-op.
  "settings",
  "shAssignments",
  "shHouses",
  "shMaintenance",
  "shRooms",
  "shStaff",
  "smsHistory",
  "surveyBadges",
  "surveyConfig",
  "surveyNominations",
  "surveyRoundComments",
  "surveyRoundReactions",
  "surveyRounds",
  "surveyVotes",
  "userAccessRequests",
  "userRequests",
  "vacancies",
  "videoWatches",
];

// [parentCollection, subcollection] pairs cloned for each parent document.
export const SEED_SUBCOLLECTIONS = [
  ["news", "reactions"],
  ["conversations", "messages"],
  ["vacancies", "referrals"],
  ["dailyReports", "incidents"],
];

// How long a visitor's sandbox lives before it is reclaimed.
//
// Matched to the 3-month trial term (see licenseService.js). It used to be 7
// days, from when this was a throwaway demo — with a trial running for 90 days
// a shorter sandbox would delete the visitor's work out from under a licence
// that was still valid, which is the opposite of the argument for converting.
//
// Firestore TTL policies need billing, so scripts/prune-sandboxes.js does the
// reaping; see the registry note in the project memory.
export const SANDBOX_TTL_DAYS = 90;
